import styles from './Logo.module.css';
import logoDark from '../../logo-dark.svg';
import logo from '../../logo.svg';

function Logo({ height = 36 }) {
  return (
    <>
      <img src={logo} alt="Prime Bridge" height={height} className={styles.lightLogo} />
      <img src={logoDark} alt="Prime Bridge" height={height} className={styles.darkLogo} />
    </>
  );
}

export default Logo;
